var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShoppingBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 14,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_31_895",
    transform: "translate(-0.0769231) scale(0.0362426 0.0336538)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_31_895",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAABAklEQVRYhe2WPQrCQBCFP0XUxggpvZWgp9D75QgJglpbW1r5AxKbWGRWQpxEYxwkmAdDYOax83b2sVloUR19YAlEwEUiBBZSM8UE2AJJQWyEY4KBNEiAPTADRhJTYCe1NUaTWGaa+0rdl1pCehxfRySLz0o4c+GEFgLOsviohOMJ51S3WUCx0T6NQGvUUXJD4Fp3BwUYAnE20VVInnwPpAJdOHRehMY7SG6cb6YJcKRj4T6qw3nCyxfKJlDbSI0Q0KsgQDOsBo1XaQLOAxYTeMuE/+UBTYC7an8mwNIDzTiCVkB7D1gIcH/WJwHavR1j976/kb6uH9AmsDJqbr12i4biDquwWlT9NPUtAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShoppingBag);
export default __webpack_public_path__ + "static/media/icon-shopping-bag.116b7af7aeea3bc29683be80edeb27c4.svg";
export { ForwardRef as ReactComponent };